import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-data-filter-input',
  templateUrl: './data-filter-input.component.html',
  styleUrls: ['./data-filter-input.component.scss']
})
export class DataFilterInputComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() labelKey: string;
  @Input() placeholderKey: string;
  @Input() model: any;
  @Input() isNumber = false;
  @Input() disabled = false;
  @Input() min: number;
  @Input() max: number;
  @Input() minLength: number;
  @Input() step: number;
  @Input() helperKey: string;
  @Input() required = false;

  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

  minLengthInvalid = false;

  public ngOnInit(): void {}

  public ngAfterViewInit(): void {
    this.checkMinLength();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.disabled) {
      this.model = null;
      this.change();
    }
  }

  public change(): void {
    this.checkMinLength();
    this.modelChange.emit(this.model);
  }

  private checkMinLength(): void {
    this.minLengthInvalid = this.minLength && !this.isNumber && this.model?.length < this.minLength;
  }
}
